import { createFileRoute, Link } from "@tanstack/react-router";
import { useGetInspection } from "@/api/client-inspection";
import { PageStatus } from "@/components/page-status";
import { Button } from "@/components/ui/button";
import {
  DetailCardSkeleton,
  DetailHeaderSkeleton,
} from "@/components/ui/detail-skeleton";
import { requireMinRole } from "@/lib/route-guards";
import { HACFormView } from "@/sections/inspections/view/hac-form-view";

// Mirrors HACFormView's WorkflowChrome: non-sticky workflow header + the
// digital form body (a stack of check-item cards).
function HACFormSkeleton() {
  return (
    <div className="flex min-h-full flex-col bg-background">
      <DetailHeaderSkeleton sticky={false} eyebrow subtitle trailingPills={1} />
      <div className="flex-1 p-6">
        <div className="mx-auto max-w-3xl space-y-4">
          <DetailCardSkeleton rows={5} />
          <DetailCardSkeleton rows={6} />
        </div>
      </div>
    </div>
  );
}

function HACFormPage() {
  const { inspectionId } = Route.useParams();
  const { data, isLoading } = useGetInspection(inspectionId);

  if (isLoading) {
    return <HACFormSkeleton />;
  }

  if (!data) {
    return (
      <PageStatus
        variant="not-found"
        title="Inspection not found"
        description="This inspection may have been removed, or the reference in the link is incorrect. Check the reference and try again from the inspections list."
        actions={
          <Button
            nativeButton={false}
            render={<Link to="/dashboard/inspections" />}
          >
            Back to inspections
          </Button>
        }
      />
    );
  }

  return <HACFormView inspection={data} />;
}

export const Route = createFileRoute(
  "/dashboard/inspections/$inspectionId/hac-form",
)({
  component: HACFormPage,
  beforeLoad: ({ context }) => {
    requireMinRole(context.session, "inspector");
  },
  staticData: {
    title: "HAC Form",
    parent: { title: "Inspections", path: "/dashboard/inspections" },
  },
});
